import { render, staticRenderFns } from "./skuDetail.vue?vue&type=template&id=77f835da&scoped=true"
import script from "./skuDetail.vue?vue&type=script&lang=js"
export * from "./skuDetail.vue?vue&type=script&lang=js"
import style0 from "./skuDetail.vue?vue&type=style&index=0&id=77f835da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f835da",
  null
  
)

export default component.exports